<template>
  <div class="mobile-filter">
    <div class="mobile-filter-current" @click="showList = true">
      {{ $t(currentOption.label) }}
    </div>
    <Transition name="mobile-filter">
      <div v-show="showList" class="mobile-filter-list">
        <div class="mobile-filter-close" @click="close">
          <svg viewBox="0 0 384 512">
            <path
              d="M345 137l17-17L328 86.1l-17 17-119 119L73 103l-17-17L22.1 120l17 17 119 119L39 375l-17 17L56 425.9l17-17 119-119L311 409l17 17L361.9 392l-17-17-119-119L345 137z"
            />
          </svg>
        </div>
        <div
          v-for="(option, index) in options"
          :key="index"
          class="mobile-filter-item"
          @click="
            $emit('update:modelValue', option.value);
            showList = false;
          "
        >
          <div>
            {{ $t(option.label) }}
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
export default {
  props: ["modelValue"],
  data: () => ({
    options: [
      { value: null, label: "all_ceremonies" },
      { value: 5, label: "ceremony_1_2026" },
      { value: 6, label: "ceremony_2_2026" },
      { value: 7, label: "ceremony_3_2026" },
      { value: 8, label: "ceremony_4_2026" },
    ],
    showList: false,
  }),
  computed: {
    currentOption() {
      return this.options.find((option) => option.value === this.modelValue);
    },
  },
  methods: {
    close() {
      this.showList = false;
    },
  },
};
</script>

<style lang="scss">
.mobile-filter {
  @media (min-width: 1250px) {
    display: none;
  }
}

.mobile-filter-current {
  padding: 10px 15px;
  border: solid #000;
  border-width: 0 2px 0 0;
  cursor: pointer;

  @media (min-width: 640px) {
    padding: 10px 30px;
    border-width: 0 2px;
  }
}

.mobile-filter-list {
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #00a0a4;
  z-index: 1;
}

.mobile-filter-enter-active,
.mobile-filter-leave-active {
  transition: all 0.2s;
}

.mobile-filter-enter-from,
.mobile-filter-leave-to {
  opacity: 0;
  transform: scale(0.8);
}

.mobile-filter-close {
  position: absolute;
  top: 30px;
  right: 30px;
  cursor: pointer;
  z-index: 10;

  svg {
    width: 40px;
    fill: #eae335;
  }
}

.mobile-filter-item {
  padding: 20px 0;
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;
}
</style>
